// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"1bed3c81","254":"5cc6276e","261":"fa297eb2","556":"ffd159f0","794":"411aa803","827":"1f9404e7","944":"bd2b2072","951":"941859ee"}[chunkId] + ".chunk.js";
};